import React from "react";
import MobileFirstFileInput from "../fileInput/MobileFirstFileInput";
import { resolveSellerEmails } from "../../api/team";

// `cod` viaja de paso hacia MobileFirstFileInput: decide qué plantilla se ofrece y si
// la columna "Cobrar" del archivo se lee o se ignora.
//
// `isSalesSupervisor` hace lo mismo con la columna "Correo del vendedor". El gate
// de verdad está en el backend (ignora la columna si quien carga no es supervisor);
// acá sólo se decide si se lee y se valida, para no mostrar errores de una columna
// que igual se iba a descartar.
//
// `coverage` = { names, index } de las comunas que cubre el operador del comercio,
// o `null` si no se pudo resolver (y entonces la comuna no se valida).
export default function ExcelUploadStep({
  fileName,
  onSelectDocument,
  cod,
  isSalesSupervisor,
  coverage,
  coverageStatus,
  coverageError,
}) {
  return (
    <div className="excel-upload">
      <MobileFirstFileInput
        onSelectDocument={onSelectDocument}
        cod={cod}
        isSalesSupervisor={isSalesSupervisor}
        resolveSellerEmails={resolveSellerEmails}
        coverage={coverage}
        coverageStatus={coverageStatus}
        coverageError={coverageError}
      />
    </div>
  );
}
